import React from "react";
import { CheckCircle } from "lucide-react";

const Hero = () => (
  <section className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-32 px-6 text-center relative overflow-hidden">
    {/* Decorative SVG Background Accent with Animation */}
    <svg
      className="absolute left-0 bottom-0 w-80 h-80 opacity-20 pointer-events-none animate-pulse"
      viewBox="0 0 200 200"
      data-aos="zoom-in"
      data-aos-delay="200"
    >
      <circle cx="100" cy="100" r="100" fill="#7c3aed" />
    </svg>
    <div className="container mx-auto relative z-10">
      <span
        className="inline-flex items-center gap-2 bg-white/10 rounded-full px-4 py-2 mb-4 text-sm font-medium uppercase tracking-wide transition-colors duration-500 hover:text-yellow-300"
        data-aos="fade-up"
      >
        <CheckCircle size={20} className="text-yellow-300 transition-colors duration-500 hover:text-white" />
        Trusted by 150+ businesses
      </span>
      <h1
        className="text-5xl md:text-7xl font-extrabold mb-6 drop-shadow-lg animate-fadeIn"
        data-aos="fade-up"
        data-aos-delay="100"
        style={{
          transition: "color 0.5s ease",
          color: "white",
        }}
        onMouseEnter={(e) => (e.target.style.color = "#FFD700")}
        onMouseLeave={(e) => (e.target.style.color = "white")}
      >
        Welcome to <span className="transition-colors duration-500 hover:text-white">Pixel Prime</span>
      </h1>
      <p
        className="text-lg max-w-2xl mx-auto mb-8 animate-fadeIn delay-100"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        Building modern, fast & responsive websites for ambitious businesses and startups.
      </p>
      <a
        href="#contact"
        className="bg-yellow-400 text-gray-900 px-8 py-4 rounded-lg font-semibold shadow-lg hover:bg-yellow-300 active:scale-95 transition-transform duration-150 inline-block text-lg focus:outline-none focus:ring-2 focus:ring-yellow-300 animate-bounce"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        Get Free Quote
      </a>
    </div>
  </section>
);

export default Hero;